import api from "./api";

// =====================================================
// LOGIN
// =====================================================

export const login = (data) => {
  return api.post("/auth/login", data);
};


// =====================================================
// PASSWORD RESET
// =====================================================

// Send OTP to registered email
export const sendPasswordResetOtp = (email) => {
  return api.post("/auth/forgot-password", {
    email,
  });
};

// Verify password reset OTP
export const verifyPasswordResetOtp = (email, otp) => {
  return api.post("/auth/verify-password-reset-otp", {
    email,
    otp,
  });
};

// Set new password
export const resetPassword = (
  email,
  otp,
  newPassword,
  confirmPassword
) => {
  return api.post("/auth/reset-password", {
    email,
    otp,
    newPassword,
    confirmPassword,
  });
};


// =====================================================
// TWO-FACTOR AUTHENTICATION RESET
// =====================================================

// Send OTP to registered email for 2FA reset
export const sendTwoFactorResetOtp = (email) => {
  return api.post("/auth/2fa/reset/send-otp", {
    email,
  });
};

// Verify OTP and reset 2FA
export const resetTwoFactor = (email, otp) => {
  return api.post("/auth/2fa/reset", {
    email,
    otp,
  });
};


// =====================================================
// TRUSTED SESSION
// =====================================================

export const getTrustedSession = () => {
  return api.get("/auth/trusted-session");
};

// Continue login with selected trusted profile
export const continueTrustedSession = (adminId) => {
  return api.post("/auth/continue-trusted-session", {
    adminId,
  });
};

// Remove selected profile from current device
export const removeTrustedDevice = (adminId) => {
  return api.delete("/auth/remove-trusted-device", {
    data: {
      adminId,
    },
  });
};


// =====================================================
// REGISTER
// =====================================================

export const register = (data) => {
  return api.post("/auth/register", data);
};


// =====================================================
// USERS
// =====================================================

export const getUsers = () => {
  return api.get("/auth/users");
};

export const updateUser = (id, data) => {
  return api.put(`/auth/users/${id}`, data);
};

export const deleteUser = (id) => {
  return api.delete(`/auth/users/${id}`);
};

export const unlockUser = (id) => {
  return api.put(`/auth/users/${id}/unlock`);
};


// =====================================================
// PASSWORD
// =====================================================

export const changePassword = (data) => {
  return api.put("/auth/change-password", data);
};


// =====================================================
// PROFILE
// =====================================================

export const getProfile = () => {
  return api.get("/auth/profile");
};


// =====================================================
// TWO-FACTOR AUTHENTICATION
// =====================================================

export const setup2FA = () => {
  return api.post("/auth/2fa/setup");
};

export const enable2FA = (token) => {
  return api.post("/auth/2fa/enable", {
    token,
  });
};

export const disable2FA = (password) => {
  return api.post("/auth/2fa/disable", {
    password,
  });
};


// =====================================================
// CURRENT DEVICE
// =====================================================

export const getCurrentDevice = () => {
  return api.get("/auth/current-device");
};


// =====================================================
// LOGIN TWO-FACTOR VERIFICATION
// =====================================================

export const verifyLoginTwoFactor = (
  twoFactorToken,
  token,
  trustDevice
) => {
  return api.post("/auth/2fa/verify-login", {
    twoFactorToken,
    token,
    trustDevice,
  });
};